package com.willandsons.lovenearby.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initTermsPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("Terms.md", FrontMatterElement.Builder { addScalar("title", "Terms and Conditions"); }))
}

@Page("/terms")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun TermsPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("terms-and-conditions-of-app-use") }) {
        org.jetbrains.compose.web.dom.Text("TERMS AND CONDITIONS OF APP USE")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("last-updated-august-2026") }) {
        org.jetbrains.compose.web.dom.Text("Last updated: August 2026")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Welcome to our app! Using this matchmaking and dating platform is governed by these Terms and Conditions (hereinafter referred to as the “Agreement”). By creating an account, downloading, or using the app, you agree to fully comply with these rules. If you don’t agree, please do not install or use the app.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("1-platform-owner-operator") }) {
        org.jetbrains.compose.web.dom.Text("1. PLATFORM OWNER (OPERATOR)")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The mobile app is solely owned and managed by Willandsons Services SRL, based in Târgu Mureș, Parangului Street, no. 56/37, Mureș County, Romania. Registered at the Trade Register Office under no. J26/1757/2022, Unique Registration Code (CUI) RO46847721, contact email: ")
        com.varabyte.kobweb.silk.components.navigation.Link("mailto:groszvilmos@willandsons.com") {
            org.jetbrains.compose.web.dom.Text("groszvilmos@willandsons.com")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("2-eligibility-conditions-and-age-verification") }) {
        org.jetbrains.compose.web.dom.Text("2. ELIGIBILITY CONDITIONS AND AGE VERIFICATION")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Minimum Age: To create an account and use this app, you must be at least 18 years old. The platform is intended for adults only.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Identity Verification (Didit): To ensure community safety and prevent minors from gaining access, the registration process includes mandatory age and identity verification through our tech partner Didit. Users agree to follow the verification steps (scanning an official document and/or facial verification). Refusing or failing the verification will automatically result in the account creation being denied.")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("3-account-creation-and-data-security") }) {
        org.jetbrains.compose.web.dom.Text("3. ACCOUNT CREATION AND DATA SECURITY")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("You are responsible for keeping your login details (email, password) confidential and for all activities that happen under your account.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("You agree to provide real, accurate, and up-to-date information. Creating fake profiles, using photos that aren't yours, or pretending to be someone else is strictly forbidden.")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("4-rules-of-conduct-and-community") }) {
        org.jetbrains.compose.web.dom.Text("4. RULES OF CONDUCT AND COMMUNITY")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The platform promotes respectful behavior. The following are strictly prohibited:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Harassment, abuse, vulgar language, threats, or discriminatory behavior in the chat section or through profile elements.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Posting photos or content that is explicitly pornographic, fully nude, violent, or featuring weapons.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Using the app for commercial purposes, advertising, propaganda, or financial scam schemes.")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("5-moderation-suspension-and-ban") }) {
        org.jetbrains.compose.web.dom.Text("5. MODERATION, SUSPENSION, AND BAN")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Reporting Mechanism: Users have access to a reporting feature to flag suspicious profiles or abusive behavior.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Human Review: All reports are manually reviewed by a human administrator at Willandsons Services SRL.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Right of Termination: The operator reserves the exclusive right to temporarily suspend or permanently delete, without notice and without compensation, any account that violates these rules of conduct.")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("6-premium-services-purchases-and-stripe-service") }) {
        org.jetbrains.compose.web.dom.Text("6. PREMIUM SERVICES, PURCHASES, AND STRIPE SERVICE")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The app can be downloaded for free, but it includes premium features and optional paid subscriptions.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Payment processing: All financial transactions are securely processed through the authorized Stripe platform. Willandsons Services SRL does not collect or store your full bank card details.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Refund policy: According to European legislation on digital services with immediate execution, purchases of digital premium features or subscriptions that are already activated are non-refundable.")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("7-intellectual-property") }) {
        org.jetbrains.compose.web.dom.Text("7. INTELLECTUAL PROPERTY")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Willandsons Services SRL owns all the intellectual property rights related to the app's content, design, source code, trademarks, logos, and graphics. Copying, modifying, or sharing them without the company's prior written consent is strictly prohibited.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("8-limitation-of-liability") }) {
        org.jetbrains.compose.web.dom.Text("8. LIMITATION OF LIABILITY")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The operator provides the platform \"as is\" and does not guarantee that users will find matches or that interactions will lead to successful meetups.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The operator is not responsible for user behavior outside the app or during in-person meetings. We recommend exercising maximum caution when interacting with strangers.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Chat messages are securely stored on Google Cloud (Firebase) for the duration of your account, but users are advised not to send confidential information (like bank details or passwords) through the chat.")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("9-changes-to-the-terms-and-applicable-law") }) {
        org.jetbrains.compose.web.dom.Text("9. CHANGES TO THE TERMS AND APPLICABLE LAW")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("We reserve the right to modify these Terms based on the development of the app or legislative changes. Users will be notified within the app about major changes.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("This Agreement is governed by Romanian law. Any dispute that cannot be resolved amicably will be submitted to the competent courts in Târgu Mureș, Romania.")
        }
    }
}
